import Rete from "rete";

export class ActionInput extends Rete.Input {
    constructor(key, title, socket, multiConns = false) {
        super(key, title, socket, multiConns);
        this.props = {}
    }
}